var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58691 8.00005L7.19358 9.61339L10.4136 6.38672",
    stroke: "#3E444A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16691 1.63338C7.62691 1.24005 8.38025 1.24005 8.84691 1.63338L9.90025 2.54005C10.1002 2.71338 10.4736 2.85338 10.7402 2.85338H11.8736C12.5802 2.85338 13.1602 3.43338 13.1602 4.14005V5.27338C13.1602 5.53338 13.3002 5.91338 13.4736 6.11338L14.3802 7.16671C14.7736 7.62671 14.7736 8.38005 14.3802 8.84671L13.4736 9.90005C13.3002 10.1 13.1602 10.4734 13.1602 10.74V11.8734C13.1602 12.58 12.5802 13.16 11.8736 13.16H10.7402C10.4802 13.16 10.1002 13.3 9.90025 13.4734L8.84691 14.38C8.38691 14.7734 7.63358 14.7734 7.16691 14.38L6.11358 13.4734C5.91358 13.3 5.54025 13.16 5.27358 13.16H4.12025C3.41358 13.16 2.83358 12.58 2.83358 11.8734V10.7334C2.83358 10.4734 2.69358 10.1 2.52691 9.90005L1.62691 8.84005C1.24025 8.38005 1.24025 7.63338 1.62691 7.17338L2.52691 6.11338C2.69358 5.91338 2.83358 5.54005 2.83358 5.28005V4.13338C2.83358 3.42671 3.41358 2.84671 4.12025 2.84671H5.27358C5.53358 2.84671 5.91358 2.70671 6.11358 2.53338L7.16691 1.63338Z",
    stroke: "#3E444A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.2fe339352fb3e8ba80abf5065d760817.svg";
export { ForwardRef as ReactComponent };